// Утилиты для сессии админа в localStorage

const KEY = "admin_session_v1";

export function getSession() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        if (!data || !data.token || !data.expiresAt) return null;
        if (Date.now() > data.expiresAt) {
            localStorage.removeItem(KEY);
            return null;
        }
        return data;
    } catch {
        return null;
    }
}

export function setSession(minutes = 180) {
    const token = crypto.getRandomValues(new Uint32Array(4)).join("-");
    const expiresAt = Date.now() + minutes * 60 * 1000;
    const payload = { token, issuedAt: Date.now(), expiresAt };
    localStorage.setItem(KEY, JSON.stringify(payload));
    return payload;
}

export function clearSession() {
    localStorage.removeItem(KEY);
}

export function getSessionMinutesFromEnv() {
    const v = parseInt(process.env.REACT_APP_ADMIN_SESSION_MINUTES, 10);
    return Number.isFinite(v) && v > 0 ? v : 180;
}
